import React, { Component } from "react";

class Homecard extends Component {
  state = {};
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div className="home-card">
        <section id="team" className="basic">
          <h5>Homepage</h5>
          <i id="djmpodcast">
            <a href="../../..">djmcloud podcast</a>
          </i>
        </section>
      </div>
    );
  }
}

export default Homecard;



// WEBPACK FOOTER //
// ./src/homecard.js